{
  "help": "Pomoc",
  "info": "Informácie"
}
